import { NavLink } from 'react-router-dom'
import { LayoutGrid, ListChecks, Menu, type LucideIcon } from 'lucide-react'

interface BottomNavProps {
  onAbrirMenu: () => void
}

interface ItemNav {
  to: string
  label: string
  icon: LucideIcon
}

const itens: ItemNav[] = [
  { to: '/dashboard', label: 'Início', icon: LayoutGrid },
  { to: '/protocolos', label: 'Requerimentos', icon: ListChecks },
]

/** Barra inferior fixa, no estilo de aplicação móvel. */
function BottomNav({ onAbrirMenu }: BottomNavProps) {
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur border-t border-[#E7E9EC] pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-3">
        {itens.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 py-2.5 transition-colors ${
                isActive ? 'text-[#1E4FBF]' : 'text-[#8A8F99]'
              }`}
          >
            {({ isActive }) => (
              <>
                <Icon className="w-5 h-5" strokeWidth={isActive ? 2.1 : 1.8} />
                <span className="text-[10.5px] font-medium leading-none">{label}</span>
              </>
            )}
          </NavLink>
        ))}
        <button
          onClick={onAbrirMenu}
          className="flex flex-col items-center justify-center gap-1 py-2.5 text-[#8A8F99] active:bg-[#F5F6F8] transition-colors"
        >
          <Menu className="w-5 h-5" strokeWidth={1.8} />
          <span className="text-[10.5px] font-medium leading-none">Menu</span>
        </button>
      </div>
    </nav>
  )
}

export default BottomNav
